import api from './client';

export const getFuseList = (switchboardId) => api.get('/reports/fuse-list', { params: { switchboard: switchboardId } });

export const getMeggerTests      = (switchboardId) => api.get('/reports/megger', { params: { switchboard: switchboardId } });
export const createMeggerTest    = (data) => api.post('/reports/megger', data);
export const updateMeggerTest    = (id, data) => api.put(`/reports/megger/${id}`, data);
export const updateMeggerRow     = (id, rowId, data) => api.patch(`/reports/megger/${id}/rows/${rowId}`, data);
export const addNewMeggerCables  = (id) => api.post(`/reports/megger/${id}/add-new`);
export const deleteMeggerTest    = (id) => api.delete(`/reports/megger/${id}`);
